import type { Params, UIMatch } from 'react-router';

type RouteText = string | ((params: Params) => string);

/**
 * Metadata attached to route objects via `handle`.
 * Used for the document title and breadcrumbs; extend (e.g. with required permissions) as needed.
 */
export interface RouteHandle {
  title?: RouteText;
  breadcrumb?: RouteText;
}

export function getRouteHandle(match: UIMatch): RouteHandle | undefined {
  const { handle } = match;
  return typeof handle === 'object' && handle !== null ? handle : undefined;
}

export function resolveRouteText(text: RouteText | undefined, params: Params): string | undefined {
  return typeof text === 'function' ? text(params) : text;
}
